import Head from '@components/common/head'

import ExplorePage from '@pages/explore'
import useSWR from 'swr'
import { getLatest } from '@/data/api/feed'
import { MediaIndex, SoundIndex, UserIndex } from '@/interfaces/algolia'
import { getFeatureSound, getFeatureUser } from '@/utils/algolia/recommend'

interface Props {
  featuredSound?: SoundIndex[]
  featuredUser?: UserIndex[]
  mediaList?: MediaIndex[]
}

const Explore = ({
  featuredSound: fallBackFeaturedSound = [],
  featuredUser: fallbackFeaturedUser = [],
  mediaList: fallbackMediaList = [],
}: Props) => {
  const { data: featuredSound } = useSWR('/feature/sounds', () => getFeatureSound(), { fallbackData: fallBackFeaturedSound })
  const { data: featuredUser } = useSWR('/feature/users', () => getFeatureUser(), { fallbackData: fallbackFeaturedUser })
  const { data: mediaList } = useSWR([ '/feed/latest/', 1 ], () => getLatest(), { fallbackData: fallbackMediaList })
  return (
    <>
      <Head url="/explore" />
      <ExplorePage
        featuredSound={featuredSound}
        featuredUser={featuredUser}
        mediaList={mediaList}
      />
    </>
  )
}

export const getStaticProps = async () => {
  const featuredSound = await getFeatureSound()
  const featuredUser = await getFeatureUser()
  const mediaList = await getLatest()

  return {
    props: {
      featuredSound,
      featuredUser,
      mediaList,
    },
    revalidate: 60,
  }
}

export default Explore
